import {
    CHOOSE_DATA_SOURCE_MODAL_I18N_KEYS
  } from '../../../../../features/topics/components/constants/i18n/ChooseDataSourceModali18nConstants';
  
  export const CHOOSE_DATA_SOURCE_MODAL_I18N_EN = {
    [CHOOSE_DATA_SOURCE_MODAL_I18N_KEYS.getting_started_title]:         "Getting Started: Select a data source",
    [CHOOSE_DATA_SOURCE_MODAL_I18N_KEYS.getting_started_prompt]:        "The other data source can be added after the topic is created.",
    [CHOOSE_DATA_SOURCE_MODAL_I18N_KEYS.keyword_filtering_button_text]: "Social media data extracted via keyword filtering",
    [CHOOSE_DATA_SOURCE_MODAL_I18N_KEYS.upload_data_button_text]:       "Upload your own data",
  };


// WEBPACK FOOTER //
// ./src/locales/en/features/topics/components/choose_data_source_modal.i18n.en.js